import SectionHeading from "./SectionHeading";
import { discoverFinished, discoverHidden } from "@/mocks/site";

interface ColumnProps {
  title: string;
  subtitle: string;
  icon: string;
  accent: "primary" | "accent";
  items: { title: string; category: string; length: string; reason: string }[];
}

function Column({ title, subtitle, icon, accent, items }: ColumnProps) {
  const isPrimary = accent === "primary";
  return (
    <div className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
      <div className="flex items-center gap-3">
        <span
          className={`w-11 h-11 rounded-md flex items-center justify-center text-xl ${
            isPrimary ? "bg-primary-100 text-primary-600" : "bg-accent-100 text-accent-600"
          }`}
        >
          <i className={icon} aria-hidden="true"></i>
        </span>
        <div>
          <h3 className="font-heading text-foreground-950 text-xl md:text-2xl">{title}</h3>
          <p className="text-foreground-500 text-xs md:text-sm">{subtitle}</p>
        </div>
      </div>

      <ul className="mt-5 flex flex-col divide-y divide-background-200/70">
        {items.map((item) => (
          <li key={item.title} className="py-4 first:pt-0 last:pb-0 flex flex-col gap-1.5">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-medium text-foreground-950 text-sm md:text-base">{item.title}</span>
              <span className="rounded-full bg-secondary-100 text-secondary-900 text-xs px-2 py-0.5">{item.category}</span>
              <span className="text-foreground-500 text-xs">{item.length}</span>
            </div>
            <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{item.reason}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function DiscoverSection() {
  return (
    <section id="discover" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="发现更多 · 完结与冷门"
          title="一口气读完，或挖点别人没看过的"
          desc="偏好完结作品的读者可以从左边补番，喜欢新鲜题材的读者则看右边。两类都附带一句挑选理由，方便你快速判断是否合口味。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5">
          <Column
            title="完结佳作"
            subtitle="已完结，可一次性追完"
            icon="ri-checkbox-circle-line"
            accent="primary"
            items={discoverFinished}
          />
          <Column
            title="冷门佳作"
            subtitle="热度不高但口碑扎实"
            icon="ri-compass-3-line"
            accent="accent"
            items={discoverHidden}
          />
        </div>
      </div>
    </section>
  );
}